module.exports = __webpack_public_path__ + "img/xpolar.0af420f6.svg";